/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "ChatBot" }]*/

'use strict';

const ChatBot = {
    setup: function () {
        const $chatWindow = $('#ChatWindow');
        const $chatWindowBackGround = $('#ChatWindowBackground');
        const $loadingScreen = $('#ChatWindow .loading-screen');
        const chatbotIFrame = $('#ChatWindow iframe').get(0);

        let language = document.documentElement.lang;

        if (!language) {
            console.error('Could not determine page language for chatbot; using default.');
            language = 'nl';
        }

        let chatbotOrigin = '';

        if (window.location.href.indexOf('//documentation.cloud.reflex-systems.nl') !== -1) {
            // Production
            chatbotOrigin = `https://${language}-luna.cloud.reflex-systems.nl`;
        } else if (window.location.href.indexOf('//test-documentation.cloud.reflex-systems.nl') !== -1) {
            // Test
            chatbotOrigin = `https://test-${language}-luna.cloud.reflex-systems.nl`;
        } else if (window.location.href.indexOf('//localhost') !== -1) {
            // Development
            chatbotOrigin = 'http://localhost:4101';
        } else if (window.location.href.indexOf('//192.') !== -1) {
            // Development
            chatbotOrigin = 'http://192.168.0.227:4101';
        } else {
            console.error('Could not determine chatbot origin; using default.');

            // Production
            chatbotOrigin = `https://${language}-luna.cloud.reflex-systems.nl`;
        }

        // Open chatbot website in iframe
        chatbotIFrame.src = `${chatbotOrigin}?hosted=true`;

        // It is not easy to detect when cross-origin iframe content has actually been loaded
        // without an error, so we wait for 30 seconds to receive a message from the chatbot website
        // and if we don't, assume there was an error.
        let loadTimerHandle = setTimeout(() => {
            $loadingScreen.html(
                `<div class="text-center"><i class="fa-duotone fa-user-robot-xmarks text-5xl mb-2"></i><br>${window.i18n.getString('chatbot.loading_failed')}</div>`
            );
        }, 30 * 1000);

        // Show chat
        $('#OpenChat').on('click', function () {
            if (!$chatWindow.hasClass('open')) {
                $chatWindow.removeClass('hide').addClass('open');
                $chatWindowBackGround.removeClass('hide').addClass('open');

                chatbotIFrame.focus();

                // Let chatbot website know the window was opened
                chatbotIFrame.contentWindow.postMessage({ open: true }, chatbotOrigin);
            } else {
                $chatWindow.removeClass('open').addClass('hide');
                $chatWindowBackGround.removeClass('open').addClass('hide');
            }
        });

        // Hide chat
        $('#CloseChat').on('click', function () {
            $chatWindow.removeClass('open').addClass('hide');
            $chatWindowBackGround.removeClass('open').addClass('hide');
        });

        // Listen for messages coming from chatbot website in iframe
        window.addEventListener('message', event => {
            if (
                chatbotOrigin.trim().toLowerCase() !== event.origin.trim().toLowerCase() &&
                window.origin.trim().toLowerCase() !== event.origin.trim().toLowerCase()
            ) {
                console.warn(
                    `Received message from unexpected origin '${event.origin.trim().toLowerCase()}' (expected '${chatbotOrigin.trim().toLowerCase()}').`
                );
                return;
            }

            // Chatbot website has loaded
            if (event.data.loaded) {
                if (loadTimerHandle !== null) {
                    clearTimeout(loadTimerHandle);
                    loadTimerHandle = null;

                    $loadingScreen.remove();
                }
            }

            // Chatbot website message view changed size
            if (event.data.height) {
                var borderSize = $chatWindow.outerHeight() - $chatWindow.innerHeight();

                // Let the chat window grow to match the chatbot website size so that there is no scrolling
                // unless it grows too high reaching the max-height limit set in css.
                $chatWindow.css('height', event.data.height + borderSize);
            }

            // Chatbot website message view has scrolled
            if (event.data.scrollTop && event.data.scrollTop > 0) {
                $chatWindow.addClass('scrolled');
            } else {
                $chatWindow.removeClass('scrolled');
            }
        });
    },
};
